import Drawer from '@mui/material/Drawer';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel'
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

interface DefaultDrawerProps {
    isOpen: boolean;
    onClose?: () => void;
    title: React.ReactNode;
    children: any,
    actions?: any,
};


export default function DefaultDrawer(props: DefaultDrawerProps) {

    return (
        <Drawer
            anchor="right"
     variant="temporary"
            open={props.isOpen}
            ModalProps={{
                sx: { zIndex: 1300 }
            }}
            PaperProps={{
                sx: { width: { xs: '100%', sm: '90%', md: '70%', lg: '60%' }, maxWidth: 800 },
            }}

            onClose={(_, reason) =>{
                if(reason=='backdropClick' ){
                    if (props.onClose !== undefined) {
                     props.onClose();
                    }
                }
            }}>
        
            <DialogTitle alignContent={'flex-end'} >
                <Grid container>
                    <Grid item xs={8} md={8} lg={8}>
                        <Typography gutterBottom variant="h6" component="div">{props.title}</Typography>
                    </Grid>
                    <Grid item xs={4} md={4} lg={4} sx={{
                        display: 'flex',
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "flex-end"

                    }}>
                        <IconButton onClick={(e) => {
                            if (props.onClose !== undefined) {
                                props.onClose();
                            }
                        }}>
                            <CancelIcon />
                        </IconButton>
                    </Grid>
                </Grid>


            </DialogTitle>
            <DialogContent dividers>
                {props.children}

            </DialogContent>
            {props.actions !== undefined && props.actions !== null &&
                <DialogActions>
                    {props.actions()}
                </DialogActions>
            }
        </Drawer>
    );
}